import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
} from "reactstrap";
import { useDispatch } from "react-redux";
import { useCurrentUser } from "../../slices/auth/hooks";
import Loading from "../../Components/Loading";
import BrokersTable from "../../Components/Tables/BrokerTable/BrokersTable";
import { getRolesForTables, postRoleForGaId } from "../../slices/admin/thunk";
import { DASHBOARD_USER_ROLES } from "../../constants";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import Swal from "sweetalert2";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import brokerIcon from "../../assets/images/iconsRoles/brokerIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import CopyInviteLink from "../../Components/Buttons/CopyInviteLinkButton";

const DashboardGa = () => {
  const inputRef = useRef(null);
  const currentUser = useCurrentUser();

  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [modalAddBroker, setModalAddEmployerGroups] = useState(false);

  const dispatch = useDispatch();

  const [brokers, setBrokers] = useState([]);
  const [totalBrokers, setTotalBrokers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleToggleModal = () => {
    setModalAddEmployerGroups(!modalAddBroker);
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchBrokers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: DASHBOARD_USER_ROLES.GA,
          role: "brokers",
          status: "active",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setBrokers(response.data);
      setTotalBrokers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchBrokers();
  }, [currentPage, debouncedSearchTerm, dispatch, currentUser.id]);

  const handleCreateBroker = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        postRoleForGaId({
          role: "brokers",
          data: values,
          id: currentUser.id || id,
        })
      ).unwrap();

      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Broker created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setModalAddEmployerGroups(false);
        fetchBrokers();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text:
            response.error.message || "An error occurred while adding Broker",
          confirmButtonText: "OK",
        });
        setModalAddEmployerGroups(true);
        setLoadingCreate(false);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.message || "An error occurred while adding Broker",
        confirmButtonText: "OK",
      });
      setModalAddEmployerGroups(true);
      setLoadingCreate(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      {/* <Modal */}
      {modalAddBroker && (
        <AddRoleModal
          open={modalAddBroker}
          setOpen={setModalAddEmployerGroups}
          roleToAdd={DASHBOARD_USER_ROLES.BROKER}
          onCreate={handleCreateBroker}
          loading={loadingCreate}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Brokers"}
            icon={brokerIcon}
            svg={true}
            text={""}
          />
          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                  />
                </div>

                <div className="d-flex">
                  <CopyInviteLink role={DASHBOARD_USER_ROLES.BROKER} inviteCode={currentUser.inviteCode} />

                  <ButtonAddRole open={handleToggleModal} roleToAdd="Broker" />
                </div>


              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <BrokersTable
                        data={brokers}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          currentPage,
                          totalPages,
                          totalItems: totalBrokers,
                          pageSize,
                          onChangePage: handleChangePage,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardGa;
